<template>
    <div class="user-dashboard-timetracker">
        <Greetings v-if="userRole !== 'admin'" />
        <Row v-if="userRole !== 'admin'" :gutter="16">
            <Col :xs="24" :lg="12">
                <Card dis-hover class="md-margin-bottom">
                    <p style="color: #463c6e; font-size: 18px; font-weight: 600; margin-bottom: 15px">Attendance</p>
                    <div class="d-flex-center space-between att-project-selector">
                        <p
                            v-if="
                                attendanceLogData &&
                                attendanceLogData.clockInTime != null &&
                                attendanceLogData.clockOutTime == null
                            "
                            class="lg-margin-right"
                        >
                            Last clock in: {{ lastClockIn }}
                        </p>
                        <p v-else class="lg-margin-right">Last clock out: {{ lastClockOut }}</p>
                        <Button v-if="canHalfDayCLockOut" class="pt-btn-1" :loading="isLoading" @click="VerifyClockOut">
                            {{ halfDayClockLabel }} Clock Out
                        </Button>
                        <Button
                            v-else-if="canPmClockOut || canAmClockOut"
                            class="pt-btn-1"
                            :loading="isLoading"
                            @click="VerifyClockOut"
                        >
                            {{ halfDayClockLabel }} Clock Out
                        </Button>
                        <Button
                            v-else-if="canAmClockIn || canPmClockIn || canHalfDayCLockIn"
                            class="pt-btn-4"
                            @click="VerifyClockedIn"
                        >
                            {{ halfDayClockLabel }} Clock In
                        </Button>
                        <Button
                            v-else-if="
                                attendanceLogData &&
                                attendanceLogData.clockInTime != null &&
                                attendanceLogData.clockOutTime == null
                            "
                            class="pt-btn-1"
                            :loading="isLoading"
                            :disabled="timeLogData && timeLogData.startTime != null && timeLogData.endTime == null"
                            @click="VerifyClockOut"
                        >
                            Clock Out
                        </Button>
                        <Button
                            v-else-if="isEmployeeOnHalfDayLeave"
                            class="pt-btn-1"
                            :loading="isLoading"
                            disabled
                            @click="VerifyClockOut"
                        >
                            On {{ halfDayLeaveLabel }} Leave
                        </Button>
                        <Button
                            v-else-if="isEmployeeOnLeave"
                            class="pt-btn-1"
                            :loading="isLoading"
                            disabled
                            @click="VerifyClockOut"
                        >
                            ON Leave
                        </Button>
                        <Button v-else class="pt-btn-4" :loading="isLoading" @click="VerifyClockedIn">Clock In </Button>
                    </div>
                    <ClockInReminderModal ref="ClockInReminderModal" @confirm="handleClockIn" />
                    <ClockOutReminderModal ref="ClockOutReminderModal" @confirm="handleUpdateClockOut" />
                </Card>
            </Col>
            <Col :xs="24" :lg="12">
                <Card :id="userRole !== 'admin' ? '' : '#'" dis-hover class="md-margin-bottom">
                    <p style="color: #463c6e; font-size: 18px; font-weight: 600; margin-bottom: 15px">
                        Project Time Tracker
                    </p>
                    <div v-if="userRole === 'admin'" class="d-flex-center project-selector" style="margin-bottom: 10px">
                        <p class="xs-margin-right">Project</p>
                        <Select
                            v-model="selectedProject"
                            :disabled="timeLogData && timeLogData.startTime != null && timeLogData.endTime == null"
                            filterable
                            clearable
                            :loading="isLoading"
                            class="md-margin-right"
                        >
                            <Option v-for="item in projectsList" :key="item.value" :value="item.value">
                                {{ item.label }}
                            </Option>
                        </Select>
                        <Button
                            v-if="timeLogData && timeLogData.startTime != null && timeLogData.endTime == null"
                            class="pt-btn-1"
                            :loading="isLoading"
                            @click="VerifySalariumCheckedOut"
                        >
                            End Time
                        </Button>
                        <Button
                            v-else
                            class="pt-btn-4"
                            :loading="isLoading"
                            :disabled="selectedProject != null ? false : true"
                            @click="VerifySalariumCheckedIn"
                        >
                            Start Time
                        </Button>
                    </div>
                    <div v-else class="d-flex-center project-selector">
                        <p class="xs-margin-right">Project</p>
                        <Select
                            v-model="selectedProject"
                            :disabled="
                                !attendanceLogData ||
                                (attendanceLogData &&
                                    timeLogData &&
                                    timeLogData.startTime != null &&
                                    timeLogData.endTime == null)
                            "
                            filterable
                            clearable
                            :loading="isLoading"
                            class="md-margin-right"
                        >
                            <Option v-for="item in projectsList" :key="item.value" :value="item.value">
                                {{ item.label }}
                            </Option>
                        </Select>
                        <Button
                            v-if="timeLogData && timeLogData.startTime != null && timeLogData.endTime == null"
                            class="pt-btn-1"
                            :loading="isLoading"
                            @click="handleUpdateEndTime(true)"
                        >
                            End Time
                        </Button>
                        <Button
                            v-else
                            class="pt-btn-4"
                            :loading="isLoading"
                            :disabled="selectedProject != null ? false : true"
                            @click="handlePostStartTime(true)"
                        >
                            Start Time
                        </Button>
                    </div>
                </Card>
            </Col>
        </Row>
        <Card v-else :id="userRole !== 'admin' ? '' : '#'" dis-hover class="md-margin-bottom">
            <p style="color: #463c6e; font-size: 18px; font-weight: 600; margin-bottom: 15px">Project Time Tracker</p>
            <div v-if="userRole === 'admin'" class="d-flex-center project-selector" style="margin-bottom: 10px">
                <p class="xs-margin-right">Project</p>
                <Select
                    v-model="selectedProject"
                    :disabled="timeLogData && timeLogData.startTime != null && timeLogData.endTime == null"
                    filterable
                    clearable
                    :loading="isLoading"
                    class="md-margin-right"
                >
                    <Option v-for="item in projectsList" :key="item.value" :value="item.value">
                        {{ item.label }}
                    </Option>
                </Select>
                <Button
                    v-if="timeLogData && timeLogData.startTime != null && timeLogData.endTime == null"
                    class="pt-btn-1"
                    :loading="isLoading"
                    @click="VerifySalariumCheckedOut"
                >
                    End Time
                </Button>
                <Button
                    v-else
                    class="pt-btn-4"
                    :loading="isLoading"
                    :disabled="selectedProject != null ? false : true"
                    @click="VerifySalariumCheckedIn"
                >
                    Start Time
                </Button>
            </div>
            <div v-else class="d-flex-center project-selector">
                <p class="xs-margin-right">Project</p>
                <Select
                    v-model="selectedProject"
                    :disabled="
                        !attendanceLogData ||
                        (attendanceLogData &&
                            timeLogData &&
                            timeLogData.startTime != null &&
                            timeLogData.endTime == null)
                    "
                    filterable
                    clearable
                    :loading="isLoading"
                    class="md-margin-right"
                >
                    <Option v-for="item in projectsList" :key="item.value" :value="item.value">
                        {{ item.label }}
                    </Option>
                </Select>
                <Button
                    v-if="timeLogData && timeLogData.startTime != null && timeLogData.endTime == null"
                    class="pt-btn-1"
                    :loading="isLoading"
                    @click="handleUpdateEndTime(true)"
                >
                    End Time
                </Button>
                <Button
                    v-else
                    class="pt-btn-4"
                    :loading="isLoading"
                    :disabled="selectedProject != null ? false : true"
                    @click="handlePostStartTime(true)"
                >
                    Start Time
                </Button>
            </div>
        </Card>
        <Row v-if="userRole !== 'admin'" :gutter="16">
            <Col :xs="24" :lg="12">
                <Card dis-hover>
                    <TrackerBarGraph
                        id="trackerBarGraphEmail"
                        style="height: 300px; position: relative"
                        :chartdata-sets="chartData"
                        :chartdata-labels="chartDataLabels"
                        :max-ticks="chartDataMaxTicks"
                    />
                </Card>
            </Col>
            <!-- <Col :xs="24" :lg="12">
                <AttendanceGraph />
            </Col> -->
        </Row>
        <SalariumReminderModal ref="SalariumReminderModal" @confirm="handlePostStartTime" />
        <StopSalariumReminderModal ref="StopSalariumReminderModal" @confirm="handleUpdateEndTime" />
    </div>
</template>

<script>
import { getProjectList } from '@/services/project-members.services';
import {
    postTimelogsStartV2,
    getV2UserTimelogGraph,
    updateEndTimeV2,
    getTimeTrackingByUserV2,
} from '@/services/timelogs.services';
import { getAttendanceByUserV2, postClockInV2, postClockOutV2 } from '@/services/attendancelogs.services';
// import AttendanceGraph from './AttendanceGraph.vue';
import TrackerBarGraph from '@/components/Graphs/BarChart.js';
import SalariumReminderModal from './SalariumReminderModal.vue';
import StopSalariumReminderModal from './StopSalariumReminderModal.vue';
import Greetings from './Greetings.vue';
import moment from 'moment';
import Bugsnag from '@bugsnag/js';
import { checkIfBefore2PM, checkIfBeforeEightAM } from '../../../../utility/helper';
import { getUsersById } from '@/services/users.services';
import ClockInReminderModal from '@/components/Attendance/Dev/ClockInReminderModal';
import ClockOutReminderModal from '@/components/Attendance/Dev/ClockOutReminderModal';

export default {
    components: {
        TrackerBarGraph,
        // AttendanceGraph,
        SalariumReminderModal,
        StopSalariumReminderModal,
        Greetings,
        ClockInReminderModal,
        ClockOutReminderModal,
    },

    data() {
        return {
            timeLogData: null,
            isLoading: false,
            selectedProject: null,
            projectsList: [],
            timelogList: [],
            user_id: localStorage.getItem('user_id'),
            userRole: localStorage.getItem('mainRole'),
            chartData: [],
            chartDataLabels: [],
            daily8Data: [],
            timelogsData: [],
            chartDataMaxTicks: [],
            attendanceLogData: null,
            lastClockIn: null,
            lastClockOut: null,
            isEmployeeOnLeave: false,
            isEmployeeOnHalfDayLeave: false,
            canHalfDayCLockIn: false,
            canHalfDayCLockOut: false,
            canAmClockIn: false,
            canPmClockIn: false,
            canAmClockOut: false,
            canPmClockOut: false,
            halfDayClockLabel: null,
            halfDayLeaveLabel: null,
        };
    },

    mounted() {
        this.handleGetTimelogUser();
        this.handleGetBarTimelogUser();
        this.handleGetProjects();
        this.handleGetAttendanceLogUser();
        this.handleGetUserDetails();
    },

    methods: {
        /*Project Time Logs Section*/
        handleGetProjects() {
            this.isLoading = true;
            this.projectsList = [];
            getProjectList()
                .then((res) => {
                    if (res.data.length) {
                        this.projectsList = res.data.map((i) => {
                            return {
                                label: i.project.name,
                                value: i.project.id,
                            };
                        });
                    }
                    this.isLoading = false;
                })
                .catch(() => {
                    this.$Message.error('Failed to get projects');
                    this.isLoading = false;
                });
        },

        VerifySalariumCheckedIn() {
            this.$refs.SalariumReminderModal.openModal();
        },

        VerifySalariumCheckedOut() {
            this.$refs.StopSalariumReminderModal.openModal();
        },

        handlePostStartTime(checked) {
            if (checked) {
                if (this.selectedProject != null) {
                    this.isLoading = true;
                    const data = {
                        id: this.selectedProject,
                    };
                    postTimelogsStartV2(data)
                        .then((res) => {
                            this.timeLogData = res.data;
                            this.isLoading = false;
                        })
                        .catch(() => {
                            this.$Message.error('Failed to start time');
                            this.isLoading = false;
                        });
                } else {
                    this.$Message.error('Please select a project');
                }
            }
        },

        handleGetTimelogUser() {
            this.isLoading = true;
            getTimeTrackingByUserV2()
                .then((res) => {
                    if (checkIfBeforeEightAM) {
                        this.timeLogData = res.data.filter(
                            (x) => x.endTime == null && moment(x.startTime).isSame(moment(), 'day')
                        )[0];
                    } else {
                        this.timeLogData = res.data.filter(
                            (x) => x.endTime == null && moment(x.startTime).utc().isSame(moment().utc(), 'day')
                        )[0];
                    }
                    this.selectedProject = this.timeLogData.project.id;
                    this.isLoading = false;
                })
                .catch(() => {
                    // this.$Message.error('Failed to get timelog user')
                    this.isLoading = false;
                });
        },

        handleGetBarTimelogUser() {
            this.chartData = [];
            getV2UserTimelogGraph().then((res) => {
                try {
                    if (res.data) {
                        this.chartDataLabels = res.data.dataLabel;
                        res.data.dataSets.map((i) => {
                            const dataObj = {
                                label: i.label,
                                backgroundColor: i.backgroundColor,
                                data: i.data,
                            };
                            this.chartDataMaxTicks = Math.max(...dataObj.data);
                            this.chartData.push(dataObj);
                        });
                    }
                } catch (e) {
                    Bugsnag.notify(e);
                }
            });
        },

        handleUpdateEndTime(checked) {
            if (checked) {
                this.isLoading = true;
                updateEndTimeV2(this.selectedProject)
                    .then(() => {
                        this.timeLogData = null;
                        this.isLoading = false;
                        this.handleGetBarTimelogUser();
                    })
                    .catch(() => {
                        this.$Message.error('Failed to get end time');
                        this.isLoading = false;
                    });
            }
        },
        /*Attendance Logs Section*/
        handleGetUserDetails() {
            const userId = localStorage.getItem('user_id');
            getUsersById(userId)
                .then((res) => {
                    // Stored times are Manila time labelled as UTC (7:24 AM is saved as 07:24Z),
                    // so always format with .utc() to show them as stored. Before 8 AM this used
                    // browser time, which added Manila's +8h again (7:24 AM showed as 3:24 PM).
                    if (res.data.monitoring_last_time_clock_in) {
                        this.lastClockIn = moment(res.data.monitoring_last_time_clock_in)
                            .utc()
                            .format('MM/DD/yyyy, hh:mm a');
                    }
                    if (res.data.monitoring_last_time_clock_out) {
                        this.lastClockOut = moment(res.data.monitoring_last_time_clock_out)
                            .utc()
                            .format('MM/DD/yyyy, hh:mm a');
                    }
                })
                .catch(() => {
                    this.$Message.error('Failed to get users');
                });
        },
        VerifyClockedIn() {
            this.$refs.ClockInReminderModal.openModal();
        },
        VerifyClockOut() {
            this.$refs.ClockOutReminderModal.openModal();
        },
        handleGetAttendanceLogUser() {
            this.isLoading = true;
            getAttendanceByUserV2()
                .then((res) => {
                    if (checkIfBeforeEightAM) {
                        this.attendanceLogData = res.data.filter(
                            (x) => x.clockOutTime == null && moment(x.clockInTime).isSame(moment(), 'day')
                        )[0];
                    } else {
                        this.attendanceLogData = res.data.filter(
                            (x) => x.clockOutTime == null && moment(x.clockInTime).utc().isSame(moment().utc(), 'day')
                        )[0];
                    }
                    const [onHalfDayLeave] = res.data.filter((data) =>
                        ['leave|vl|PM', 'leave|vl|AM', 'leave|sl|PM', 'leave|sl|AM'].includes(data.status)
                    );
                    const [halfDay] = res.data.filter((data) =>
                        ['regular-halfday|AM', 'regular-halfday|PM'].includes(data.status)
                    );
                    if (onHalfDayLeave) {
                        // const [halfday] = res.data
                        if (halfDay?.status.includes('regular-halfday') && !halfDay?.clockOutTime) {
                            this.canHalfDayCLockOut = true;
                            this.canHalfDayCLockIn = false;
                            this.halfDayClockLabel = halfDay.status.split('|')[1];
                            this.isEmployeeOnHalfDayLeave = false;
                        } else if (!halfDay) {
                            if (
                                //trying to halfday clockin in AM before 2pm
                                moment().format('A') === onHalfDayLeave.status.split('|')[2] &&
                                onHalfDayLeave.status.split('|')[2] === 'PM' &&
                                checkIfBefore2PM &&
                                !checkIfBeforeEightAM
                            ) {
                                console.log('1');
                                this.halfDayClockLabel = 'AM';
                                this.canHalfDayCLockIn = true;
                            } else if (
                                //on leave PM
                                moment().format('A') === onHalfDayLeave.status.split('|')[2] &&
                                onHalfDayLeave.status.split('|')[2] === 'PM' &&
                                !checkIfBefore2PM
                            ) {
                                console.log('2');
                                this.isEmployeeOnHalfDayLeave = true;
                                this.halfDayLeaveLabel = moment().format('A');
                            } else if (
                                moment().format('A') === onHalfDayLeave.status.split('|')[2] &&
                                onHalfDayLeave.status.split('|')[2] === 'AM' &&
                                !checkIfBeforeEightAM
                            ) {
                                console.log('2');
                                this.canHalfDayCLockIn = true;
                                this.halfDayLeaveLabel = moment().format('A');
                            } else if (moment().format('A') !== onHalfDayLeave.status.split('|')[2]) {
                                console.log('3');
                                this.canHalfDayCLockIn = true;
                                this.halfDayClockLabel = moment().format('A');
                                if (onHalfDayLeave.status.split('|')[2] === 'PM') {
                                    this.canAmClockIn = true;
                                    this.canPmClockIn = false;
                                } else {
                                    this.canAmClockIn = false;
                                    this.canPmClockIn = true;
                                }
                            }
                        }
                    } else {
                        if (res.data[0].status.includes('FULL') || res.data[0].status.includes('leave'))
                            this.isEmployeeOnLeave = res.data[0].status.includes('leave');
                    }
                    this.isLoading = false;
                })
                .catch(() => {
                    // this.$Message.error('Failed to get attendance logs user')
                    this.isLoading = false;
                });
        },

        handleClockIn() {
            if (this.user_id) {
                this.isLoading = true;
                postClockInV2()
                    .then(() => {
                        // this.attendanceLogData = res.data;
                        this.isLoading = false;
                        //for changing halfday clockin to halfday clockout
                        if (this.canPmClockIn) {
                            this.canPmClockIn = false;
                            this.canPmClockOut = true;
                        }
                        if (this.canAmClockIn) {
                            this.canAmClockIn = false;
                            this.canAmClockOut = true;
                        }
                        this.handleGetUserDetails();
                        this.handleGetAttendanceLogUser();
                    })
                    .catch((err) => {
                        if (err.data && err.status === 400) {
                            this.$Message.error(err.data?.message);
                        } else this.$Message.error('Failed to clock in');
                        this.isLoading = false;
                    });
            } else {
                this.$Message.error('Failed to found user');
            }
        },

        handleUpdateClockOut() {
            if (this.attendanceLogData.id) {
                this.isLoading = true;
                postClockOutV2()
                    .then(() => {
                        this.attendanceLogData = null;
                        this.selectedProject = null;
                        this.isLoading = false;
                        this.handleGetUserDetails();
                        console.log('this.canPmClockOut: ', this.canPmClockOut);
                        console.log('this.canAmClockOut: ', this.canAmClockOut);
                        console.log('this.canHalfDayCLockOut: ', this.canHalfDayCLockOut);
                        if (this.canPmClockOut) {
                            this.canPmClockIn = true;
                            this.canPmClockOut = false;
                            this.canHalfDayCLockOut = false;
                        }
                        if (this.canAmClockOut) {
                            this.canAmClockIn = true;
                            this.canAmClockOut = false;
                            this.canHalfDayCLockOut = false;
                        }
                        if (this.canHalfDayCLockOut) {
                            this.canHalfDayCLockOut = false;
                            this.canHalfDayCLockIn = true;
                        }
                    })
                    .catch(() => {
                        this.$Message.error('Failed to get clock out');
                        this.isLoading = false;
                    });
            }
        },
    },
};
</script>

<style lang="scss">
.user-dashboard-timetracker {
    .ivu-card.ivu-card-bordered.ivu-card-dis-hover {
        box-shadow: 0 1px 6px rgb(0 0 0 / 20%);
        border-color: #eee;
        border-radius: 5px;
    }
    #display-inline {
        display: inline-block;
        margin-left: 18px;
        width: 45%;
    }
    .half-width {
        width: 50%;
    }
    @media screen and (max-width: 1024px) {
        .project-selector {
            display: block;
            text-align: left;

            .ivu-select {
                margin: 0 0 10px;
            }
            button {
                width: 100%;
            }
        }
    }
}
.att-display-inline {
    display: inline-block;
    width: 50%;
}
.lg-margin-right {
    margin-right: 60px;
}
.space-between {
    justify-content: space-between;
}
@media screen and (max-width: 1024px) {
    .att-project-selector {
        display: block;
        text-align: left;

        button {
            width: 100%;
        }
    }
}
</style>
